import { Component, h } from "preact";
import { fromStyleLocals } from "../../../utils/css";
import * as style from "./ComboBox.less";
const css = fromStyleLocals(style.locals);

const serverError = "Server error";
const listGroupItem = "list-group-item";

export type Status = "Loading" | "Unauthorized" | "Server error";

interface IProps {
  getItems: () => Promise<string[]>;
  defaultItem: string;
  onChange: (tags: string) => void;
}

interface IState {
  open: boolean;
  selectedItem: string;
  tags: string[];
  filterText: string;
  hideClear: boolean;
  status: Status;
  statusClass: string;
}

export const ComboBox = class extends Component<IProps, IState> {
  private allTags: string[] = [];
  constructor(props: IProps) {
    super();
    this.state = {
      filterText: "",
      hideClear: props.defaultItem.length >= 0,
      open: false,
      selectedItem: props.defaultItem,
      status: "Loading",
      statusClass: "",
      tags: [],
    };
  }

  public componentWillMount() {
    document.addEventListener("mousedown", this.outsideClick);
    const defaultValue = this.props.defaultItem ? this.props.defaultItem : "";
    if (defaultValue) {
      this.selectItem(defaultValue, false);
    }
    this.props.onChange(defaultValue);
  }

  public componentWillUnmount() {
    document.removeEventListener("mousedown", this.outsideClick);
  }

  public render() {
    if (!this.state.tags || this.state.tags.length === 0) {
      this.makeApiCall();
    }

    return (
      <div class="form-group">
        <style>{style.toString()}</style>
        <div class="combo-box">
          <div class={css("input-group")}>
            <input
              class={css("form-control", "input-search")}
              aria-label="Combobox"
              type="text"
              value={this.state.filterText}
              onInput={this.setFilter.bind(this)}
              onClick={() => this.toggleCombo()}
            />
            <span
              hidden={this.state.hideClear}
              style="padding-right: 10px;cursor:pointer"
              onClick={() => this.clearSelection()}
            >
              {" "}
              <i class="fa fa-times" />
            </span>
            <span
              class={css("arrow-down-btn")}
              onClick={() => this.toggleCombo()}
            >
              {!this.state.open ? (
                <i class={css("fa fa-chevron-down", "chevron")} />
              ) : (
                <i class={css("fa fa-chevron-up", "chevron")} />
              )}
            </span>
          </div>

          <div
            class={css(
              "combo-box-scroll " + (this.state.open ? "" : "hidden"),
              "cmb-box"
            )}
          >
            {!this.state.tags || this.state.tags.length === 0 ? (
              <div class={css("list-group")}>
                {this.state.status === "Loading" ? (
                  <span class={css(listGroupItem)}>
                    <i class="fa fa-spinner fa-pulse fa-fw" />
                    Loading...
                  </span>
                ) : (
                  <span class={css(listGroupItem)} style="color:#b9292d">
                    <i class={css(this.state.statusClass)} />
                    {this.state.status}
                  </span>
                )}
              </div>
            ) : (
              <div class={css("list-group", "list-group-custom")}>
                {this.state.tags.map(item => (
                  <a
                    class={css(listGroupItem, "custom-list-item")}
                    onClick={() => this.selectItem(item)}
                  >
                    {item}
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  private clearSelection() {
    this.setState({
      ...this.state,
      filterText: "",
      hideClear: true,
      selectedItem: "",
    });
    this.props.onChange(this.state.selectedItem);
  }

  private toggleCombo() {
    this.setState({
      ...this.state,
      open: !this.state.open,
    });
  }

  private selectItem(item: string, toogleDdl = true) {
    this.setState({
      ...this.state,
      filterText: item,
      hideClear: false,
      selectedItem: item,
    });
    if (toogleDdl) {
      this.toggleCombo();
    }
    this.props.onChange(this.state.selectedItem);
  }

  private async makeApiCall() {
    if (
      this.state.status !== serverError &&
      this.state.status !== "Unauthorized"
    ) {
      await this.props
        .getItems()
        .then(value => this.handleSuccess(value))
        .catch(err => this.handleError(err));
    }
  }

  private setFilter(event: any) {
    const isFilterTextEmpty = event.target.value.length <= 0;
    this.setState({
      ...this.state,
      filterText: event.target.value,
      hideClear: isFilterTextEmpty,
      open: true,
    });
    const newTags = this.getVisibleChoices();
    if (isFilterTextEmpty) {
      this.setState({ ...this.state, selectedItem: "" });
      this.props.onChange(this.state.selectedItem);
    }
    this.setTags(newTags);
  }

  private setTags(tagsUpdated: string[]) {
    this.setState({ ...this.state, tags: tagsUpdated });
  }

  private getVisibleChoices(): string[] {
    if (!this.state.filterText || this.state.filterText.length === 0) {
      return this.allTags;
    }
    return this.state.tags.filter(tag => {
      return (
        tag
          .toLocaleLowerCase()
          .indexOf(this.state.filterText.toLocaleLowerCase()) >= 0
      );
    });
  }

  private outsideClick(e: any) {
    if (!this.base || this.base.contains((e.path && e.path[0]) || e.target)) {
      return false;
    }
    this.setState({ ...this.state, open: false });
    return true;
  }

  private handleError(error: any) {
    if (error.toString().indexOf("Unauthorized") > -1) {
      this.setState({
        ...this.state,
        status: "Unauthorized",
        statusClass: "fa fa-ban",
      });
    } else {
      this.setState({
        ...this.state,
        status: serverError,
        statusClass: "fa fa-times",
      });
    }
  }
  private handleSuccess(result: any) {
    if (result) {
      result.sort((a: any, b: any) => a.localeCompare(b));
      this.setState({ ...this.state, tags: result });
      this.allTags = result;
    }
  }
};
